module.exports = __webpack_public_path__ + "img/stop_white.ed403217.svg";